import { collection, addDoc } from 'firebase/firestore';
import { db } from './lib/firebase';

// Demo recipes for seeding
export const demoRecipes = [
  {
    title: 'Klassische Spaghetti Bolognese',
    description: 'Ein herzhaftes italienisches Nudelgericht mit würziger Fleischsauce.',
    imageUrl: 'https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg',
    category: 'abendessen',
    difficulty: 'mittel',
    prepTime: 45,
    servings: 4,
    ingredients: [
      '400g Spaghetti',
      '500g Rinderhackfleisch',
      '1 Dose gehackte Tomaten (400g)',
      '2 Zwiebeln, gewürfelt',
      '3 Knoblauchzehen, gehackt',
      '2 EL Tomatenmark',
      '1 Karotte, gewürfelt',
      '1 Stange Sellerie, gewürfelt',
      '150ml Rotwein',
      'Olivenöl, Salz, Pfeffer, Oregano'
    ],
    instructions: [
      'Zwiebeln, Knoblauch, Karotte und Sellerie in Olivenöl anschwitzen.',
      'Hackfleisch hinzufügen und krümelig anbraten.',
      'Tomatenmark einrühren und kurz mitrösten.',
      'Mit Rotwein ablöschen und einkochen lassen.',
      'Gehackte Tomaten und Gewürze hinzufügen, 30 Minuten köcheln lassen.',
      'Spaghetti nach Packungsanweisung kochen.',
      'Nudeln mit Sauce servieren und mit Parmesan bestreuen.'
    ],
    tips: 'Die Sauce schmeckt am besten, wenn sie lange köchelt. Bereite sie am Vortag zu!',
    createdAt: new Date().toISOString()
  },
  {
    title: 'Fluffige Pancakes mit Beeren',
    description: 'Amerikanische Pfannkuchen - fluffig, süß und perfekt zum Frühstück.',
    imageUrl: 'https://images.pexels.com/photos/376464/pexels-photo-376464.jpeg',
    category: 'fruehstueck',
    difficulty: 'einfach',
    prepTime: 20,
    servings: 4,
    ingredients: [
      '200g Mehl',
      '2 EL Zucker',
      '1 TL Backpulver',
      '1/2 TL Natron',
      '1 Prise Salz',
      '250ml Buttermilch',
      '1 Ei',
      '30g geschmolzene Butter',
      'Frische Beeren zum Servieren',
      'Ahornsirup'
    ],
    instructions: [
      'Trockene Zutaten in einer Schüssel vermischen.',
      'Buttermilch, Ei und geschmolzene Butter verquirlen.',
      'Flüssige Zutaten zu den trockenen geben und kurz verrühren (Klümpchen sind ok!).',
      'Pfanne mit etwas Butter erhitzen.',
      'Teig portionsweise in die Pfanne geben.',
      'Bei Blasenbildung wenden, goldbraun backen.',
      'Mit frischen Beeren und Ahornsirup servieren.'
    ],
    tips: 'Den Teig nicht zu viel rühren - das macht die Pancakes zäh!',
    createdAt: new Date().toISOString()
  },
  {
    title: 'Cremige Tomatensuppe',
    description: 'Eine samtige Tomatensuppe - perfekt für kalte Tage.',
    imageUrl: 'https://images.pexels.com/photos/1618888/pexels-photo-1618888.jpeg',
    category: 'vorspeise',
    difficulty: 'einfach',
    prepTime: 30,
    servings: 4,
    ingredients: [
      '1kg reife Tomaten',
      '1 große Zwiebel',
      '3 Knoblauchzehen',
      '500ml Gemüsebrühe',
      '100ml Sahne',
      '2 EL Olivenöl',
      'Frisches Basilikum',
      'Salz, Pfeffer, Zucker'
    ],
    instructions: [
      'Tomaten halbieren und mit Olivenöl, Salz und Knoblauch im Ofen bei 200°C 20 Min. rösten.',
      'Zwiebel in einem Topf glasig dünsten.',
      'Geröstete Tomaten und Brühe hinzufügen.',
      '10 Minuten köcheln lassen.',
      'Mit einem Pürierstab cremig mixen.',
      'Sahne einrühren und mit Salz, Pfeffer und einer Prise Zucker abschmecken.',
      'Mit frischem Basilikum garnieren.'
    ],
    tips: 'Das Rösten der Tomaten intensiviert den Geschmack enorm!',
    createdAt: new Date().toISOString()
  },
  {
    title: 'Schokoladen-Lava-Kuchen',
    description: 'Kleine Schokoladenkuchen mit flüssigem Kern - ein Traum!',
    imageUrl: 'https://images.pexels.com/photos/5429051/pexels-photo-5429051.png',
    category: 'dessert',
    difficulty: 'mittel',
    prepTime: 25,
    servings: 4,
    ingredients: [
      '200g dunkle Schokolade',
      '150g Butter',
      '3 Eier',
      '3 Eigelb',
      '100g Zucker',
      '50g Mehl',
      'Butter und Kakao für die Förmchen'
    ],
    instructions: [
      'Schokolade und Butter im Wasserbad schmelzen.',
      'Eier, Eigelb und Zucker schaumig schlagen.',
      'Schokoladenmischung unterheben.',
      'Mehl vorsichtig unterrühren.',
      'Gebutterte und mit Kakao bestäubte Förmchen füllen.',
      'Bei 200°C 10-12 Minuten backen.',
      'Sofort stürzen und servieren.'
    ],
    tips: 'Die Backzeit ist entscheidend - lieber eine Minute zu wenig als zu viel!',
    createdAt: new Date().toISOString()
  },
  {
    title: 'Caesar Salad',
    description: 'Der Klassiker unter den Salaten mit cremigem Dressing und knusprigen Croutons.',
    imageUrl: 'https://images.pexels.com/photos/1211887/pexels-photo-1211887.jpeg',
    category: 'mittagessen',
    difficulty: 'einfach',
    prepTime: 20,
    servings: 2,
    ingredients: [
      '1 Römersalat',
      '100g Parmesan',
      '2 Scheiben Toastbrot für Croutons',
      '2 Knoblauchzehen',
      '1 Eigelb',
      '2 EL Zitronensaft',
      '1 TL Dijon-Senf',
      '100ml Olivenöl',
      'Sardellen (optional)',
      'Salz, Pfeffer'
    ],
    instructions: [
      'Brot würfeln und mit Knoblauchöl knusprig rösten.',
      'Für das Dressing: Eigelb, Zitronensaft und Senf verrühren.',
      'Olivenöl langsam einrühren bis eine cremige Emulsion entsteht.',
      'Geriebenen Parmesan und gehackte Sardellen untermischen.',
      'Römersalat waschen und in mundgerechte Stücke zupfen.',
      'Salat mit Dressing vermengen.',
      'Mit Croutons und Parmesanspänen servieren.'
    ],
    tips: 'Das Dressing lässt sich gut vorbereiten und hält im Kühlschrank mehrere Tage.',
    createdAt: new Date().toISOString()
  },
  {
    title: 'Hummus mit Fladenbrot',
    description: 'Cremiger orientalischer Kichererbsen-Dip - perfekt als Snack oder Vorspeise.',
    imageUrl: 'https://images.pexels.com/photos/1618898/pexels-photo-1618898.jpeg',
    category: 'snack',
    difficulty: 'einfach',
    prepTime: 15,
    servings: 4,
    ingredients: [
      '400g Kichererbsen (Dose), abgetropft',
      '3 EL Tahini (Sesampaste)',
      '2 Knoblauchzehen',
      'Saft von 1 Zitrone',
      '3 EL Olivenöl',
      '1/2 TL Kreuzkümmel',
      'Paprikapulver zum Garnieren',
      'Salz nach Geschmack',
      'Fladenbrot zum Servieren'
    ],
    instructions: [
      'Kichererbsen, Tahini, Knoblauch und Zitronensaft in einen Mixer geben.',
      'Pürieren und dabei Olivenöl langsam hinzufügen.',
      'Mit Kreuzkümmel und Salz abschmecken.',
      'Bei Bedarf etwas Wasser hinzufügen für cremigere Konsistenz.',
      'In eine Schale geben und eine Mulde formen.',
      'Mit Olivenöl beträufeln und mit Paprika bestreuen.',
      'Mit warmem Fladenbrot servieren.'
    ],
    tips: 'Für extra cremigen Hummus die Kichererbsen kurz blanchieren und die Häutchen entfernen.',
    createdAt: new Date().toISOString()
  }
];

export const seedRecipes = async () => {
  try {
    const recipesCollection = collection(db, 'recipes');
    
    for (const recipe of demoRecipes) {
      await addDoc(recipesCollection, recipe);
      console.log(`Added: ${recipe.title}`);
    }
    
    console.log('All demo recipes added successfully!');
    return true;
  } catch (error) {
    console.error('Error seeding recipes:', error);
    return false;
  }
};
